import { ICON_COLLECTION } from 'assets/media/icons';
import { KebabOption } from '../models/master-data.model';

import AddNewSubCategoryIcon from 'assets/media/icons/SubCategory.svg';
import AddNewIndicator from 'assets/media/icons/Indicator.svg';
import LinkIcon from 'assets/media/icons/LinkIcon.svg';
import { IconType } from 'common/enums/controls/dropdown.enum';
import { EntityActions } from 'common/enums/actions.enum';
import { Mode } from '../enums/mode.enum';
import { EntityVM } from 'common/models/data/entity.model';
import { UseMasterDataAccess } from '../role-access-hooks/useMasterDataAccess';

export const getInitialMasterListColDefs = (
    handleExpansionToggleCallback: (data: any) => void,
    handleDetailsClickCallback: (data: any) => void,
    handleActionCallback: (action: any, data: any) => void,
    isUploadDisabled: boolean,
    uploadedUser: string,
    isSyncInProgress: boolean,
    masterDataFeatureActionList?: UseMasterDataAccess
) => [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 450,
        resizable: true,
        cellRenderer: 'nameCellRenderer',
        cellRendererParams: {
            onExpansionToggle: handleExpansionToggleCallback
        },
        cellClass: 'name-cell-custom',
        headerClass: 'name-header-custom'
    },
    {
        field: 'order',
        headerName: 'Order',
        resizable: true,
        cellRenderer: 'orderCellRenderer'
    },
    {
        field: 'details',
        headerName: 'Details',
        resizable: true,
        cellRenderer: 'detailsCellRenderer',
        cellRendererParams: {
            handleDetailsClick: handleDetailsClickCallback
        }
    },
    {
        field: 'kebab',
        headerName: '',
        minWidth: 150,
        resizable: true,
        cellClass: 'kebab-cell-custom',
        cellRenderer: 'kebabCellRenderer',
        cellRendererParams: {
            onAction: handleActionCallback,
            isUploadDisabled: isUploadDisabled,
            uploadedUser: uploadedUser,
            masterDataFeatureActionList,
            isSyncInProgress: isSyncInProgress
        }
    }
];

export const getDataListColDefs = (
    handleExpansionToggleCallback: (data: any) => void,
    handleDetailsClickCallback: (data: any) => void,
    handleActionCallback: (action: string, data: any) => void,
    errorCount: number,
    isAtleastOneErrorFixed: boolean,
    mode: string
) => [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 450,
        resizable: true,
        cellRenderer: 'nameCellRenderer',
        cellRendererParams: {
            onExpansionToggle: handleExpansionToggleCallback
        },
        cellClass: 'name-cell-custom',
        headerClass: 'name-header-custom'
    },
    {
        field: 'errors',
        headerName: 'Errors',
        resizable: true,
        cellRenderer: 'errorCellRenderer',
        headerComponent: 'errorHeaderRenderer',
        headerComponentParams: {
            count: errorCount,
            isAtleastOneErrorFixed: isAtleastOneErrorFixed
        },
        hide: !(mode === Mode.HasError || mode === Mode.ErrorCorrected),
        suppressToolPanel: !(mode === Mode.HasError || mode === Mode.ErrorCorrected)
    },
    {
        field: 'order',
        headerName: 'Order',
        resizable: true,
        cellRenderer: 'orderCellRenderer'
    },
    {
        field: 'details',
        headerName: 'Details',
        resizable: true,
        cellRenderer: 'detailsCellRenderer',
        cellRendererParams: {
            handleDetailsClick: handleDetailsClickCallback
        }
    },
    {
        field: 'actions',
        headerName: '',
        minWidth: 150,
        resizable: true,
        cellRenderer: 'actionCellRenderer',
        cellRendererParams: {
            onAction: handleActionCallback
        },
        hide: !(mode === Mode.HasError || mode === Mode.ErrorCorrected),
        suppressToolPanel: !(mode === Mode.HasError || mode === Mode.ErrorCorrected)
    },
    {
        field: 'kebab',
        headerName: '',
        minWidth: 150,
        resizable: true,
        cellClass: 'kebab-cell-custom',
        cellRenderer: 'kebabCellRenderer',
        cellRendererParams: {
            onAction: handleActionCallback
        },
        hide: mode === Mode.HasError || mode === Mode.ErrorCorrected,
        suppressToolPanel: mode === Mode.HasError || mode === Mode.ErrorCorrected
    }
];

export const CategoryKebabOptions: KebabOption[] = [
    {
        iconSrc: AddNewSubCategoryIcon,
        iconType: IconType.CustomImage,
        label: EntityActions.AddNewSubCategory,
        isActionDisabled: false
    },
    {
        iconSrc: ICON_COLLECTION.IC_Edit,
        iconType: IconType.Icon,
        label: EntityActions.Edit,
        isActionDisabled: false
    },
    {
        iconSrc: ICON_COLLECTION.IC_Archive,
        iconType: IconType.Icon,
        label: EntityActions.Archive,
        isActionDisabled: false
    },
    {
        iconSrc: ICON_COLLECTION.IC_Copy,
        iconType: IconType.Icon,
        label: EntityActions.Clone,
        isActionDisabled: false
    },
    {
        iconSrc: ICON_COLLECTION.IC_Delete,
        iconType: IconType.Icon,
        label: EntityActions.Delete,
        isActionDisabled: false
    },
    {
        iconSrc: ICON_COLLECTION.IC_Download,
        iconType: IconType.Icon,
        label: EntityActions.Export
    }
    /**
     * Do not remove this comment
     * It will be included in near future.
     */
    // {
    //     iconSrc: ICON_COLLECTION.IC_Download,
    //     iconType: IconType.Icon,
    //     label: EntityActions.Export
    // }
];

export const SubCategoryKebabOptions: KebabOption[] = [
    {
        iconSrc: AddNewSubCategoryIcon,
        iconType: IconType.CustomImage,
        label: EntityActions.AddNewSubCategory
    },
    {
        iconSrc: AddNewIndicator,
        iconType: IconType.CustomImage,
        label: EntityActions.AddNewIndicator
    },
    {
        iconSrc: ICON_COLLECTION.IC_Edit,
        iconType: IconType.Icon,
        label: EntityActions.Edit
    },
    {
        iconSrc: ICON_COLLECTION.IC_Move,
        iconType: IconType.Icon,
        label: EntityActions.Move
    },
    {
        iconSrc: ICON_COLLECTION.IC_Copy,
        iconType: IconType.Icon,
        label: EntityActions.Clone
    },
    {
        iconSrc: ICON_COLLECTION.IC_Archive,
        iconType: IconType.Icon,
        label: EntityActions.Archive
    },
    {
        iconSrc: ICON_COLLECTION.IC_Delete,
        iconType: IconType.Icon,
        label: EntityActions.Delete
    },
    {
        iconSrc: ICON_COLLECTION.IC_Download,
        iconType: IconType.Icon,
        label: EntityActions.Export
    }
    /**
     * Do not remove this comment
     * It will be included in near future.
     */
    // {
    //     iconSrc: ICON_COLLECTION.IC_Download,
    //     iconType: IconType.Icon,
    //     label: EntityActions.Export
    // }
];

export const IndicatorKebabOptions: KebabOption[] = [
    {
        iconSrc: ICON_COLLECTION.IC_Edit,
        iconType: IconType.Icon,
        label: EntityActions.Edit
    },
    {
        iconSrc: ICON_COLLECTION.IC_Move,
        iconType: IconType.Icon,
        label: EntityActions.Move
    },
    {
        iconSrc: ICON_COLLECTION.IC_Copy,
        iconType: IconType.Icon,
        label: EntityActions.Copy
    },
    {
        iconSrc: LinkIcon,
        iconType: IconType.CustomImage,
        label: EntityActions.Link
    },
    {
        iconSrc: ICON_COLLECTION.IC_Archive,
        iconType: IconType.Icon,
        label: EntityActions.Archive
    },
    {
        iconSrc: ICON_COLLECTION.IC_Delete,
        iconType: IconType.Icon,
        label: EntityActions.Delete
    },
    {
        iconSrc: ICON_COLLECTION.IC_Download,
        iconType: IconType.Icon,
        label: EntityActions.Export
    }
    /**
     * Do not remove this comment
     * It will be included in near future.
     */
    // {
    //     iconSrc: ICON_COLLECTION.IC_Download,
    //     iconType: IconType.Icon,
    //     label: EntityActions.Export
    // }
];

/**
 * Following function will be called from add subcategory popup
 * @param handleRadioClickedCallback
 * @param handleExpansionToggleCallback
 * @returns
 */
export const getHierarchyListColDefs = (
    handleRadioClickedCallback: (data: any) => void,
    handleExpansionToggleCallback: (data: any) => void,
    minWidth = 450,
    hideChildIndicatorsOnly = false,
    hideSelectionOnCategory = false,
    disbleEntity?: EntityVM,
    preventSelectionOfSubCategoriesHavingSubCategories = false,
    preventSelectionOfSubCategoriesHavingIndicators = false
) => [
    {
        field: 'name',
        headerName: '',
        minWidth: minWidth,
        resizable: true,
        cellRenderer: 'radioButtonCellRenderer',
        cellRendererParams: {
            hideChildIndicatorsOnly: hideChildIndicatorsOnly,
            hideSelectionOnCategory: hideSelectionOnCategory,
            onClickRadioButton: handleRadioClickedCallback,
            onExpansionToggle: handleExpansionToggleCallback,
            disbleEntity: disbleEntity,
            preventSelectionOfSubCategoriesHavingSubCategories:
                preventSelectionOfSubCategoriesHavingSubCategories,
            preventSelectionOfSubCategoriesHavingIndicators:
                preventSelectionOfSubCategoriesHavingIndicators
        }
    }
];

/**
 * Following function will be called from add subcategory popup
 * @param handleCheckboxClickedCallback
 * @param handleExpansionToggleCallback
 * @returns
 */
export const getHierarchyCheckboxListColDefs = (
    handleCheckboxClickedCallback: (isSelected: boolean, data: any) => void,
    handleExpansionToggleCallback: (data: any) => void,
    minWidth = 450
) => [
    {
        field: 'name',
        headerName: '',
        minWidth: minWidth,
        resizable: true,
        cellRenderer: 'CheckboxCellRenderer',
        cellRendererParams: {
            onClickCheckbox: handleCheckboxClickedCallback,
            onExpansionToggle: handleExpansionToggleCallback
        }
    }
];
